import React from 'react';

import ic_user_group_customize from 'assets/images/ic_user_group_customize.svg';

import { func_validation } from 'functions';

export const userGroupColumns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_userGroup,
    getColumns_users,
    getColumns_userGroupPermission,
}

function getColumns(props) {
    return [
        getColumns_userGroup(),
        getColumns_users(props),
        getColumns_userGroupPermission(props),
    ];
}

function getColumns_userGroup() {
    let columnClassName = "userGroup-tableColumn-userGroup";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "User Group",
        id: "userGroup",
        accessor: "GroupName",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let value_formatted = func_validation.getTableCellValue_string(props, "");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_users(props) {
    let columnClassName = "userGroup-tableColumn-totalUsers";

    return {
        headerCellClassName: "userGroup-tableColumn-totalUsers-header " + columnClassName + " ",
        Header: "Total Users",
        id: "totalUsers",
        accessor: "UserGroupMappings",
        bodyCellClassName: columnClassName + " ",
        Cell: (cellProps) => {
            let isSubrow = func_validation.isTableRowIndexSubrow(cellProps);
            let original = func_validation.getTableRowOriginalValue(cellProps);
            let selectedUsers = func_validation.getObjectPropertyValue(cellProps, "value");
            let totalUsers = func_validation.getArrayLength(selectedUsers, 0);
            let selectedIndexes = [];
            let userListDisplay = [];

            if (func_validation.isArrayNotEmpty(selectedUsers) &&
                func_validation.isUserAccessGranted(props, "Internal_UserGroupMapping_View")) {

                userListDisplay = selectedUsers.map((userObj, idx) => {
                    let username = func_validation.getObjectPropertyValue(userObj, "username");
                    let selectedIndex = func_validation.getObjectPropertyValue(userObj, "selectedIndex");
                    selectedIndexes.push(selectedIndex);

                    return (<div key={idx}>{func_validation.convertCamelCaseToWords(username)}</div>);
                })
            }

            let isUserGroupMappingHidden = func_validation.isUserAccessDenied(props, "Internal_UserGroupMapping_View");
            if (isUserGroupMappingHidden && isSubrow) return "";

            return isSubrow? (
                <div className={"userGroup-tableColumn-totalUsers-cell-subrow h-100"}>
                    {userListDisplay}
                </div>
            ):(
                <div className={"userGroup-tableColumn-totalUsers-cell"}
                    onClick={() => {
                        if (!isUserGroupMappingHidden) {
                            // User Modal
                            if (props.setIsModalVisible_user)
                                props.setIsModalVisible_user(true);

                            // User List
                            if (props.setSelectedUserIndexList &&
                                func_validation.isArray(selectedIndexes))
                                props.setSelectedUserIndexList(selectedIndexes);

                            // Set user email
                            if (props.setSelectedUserDetail &&
                                func_validation.isObjectNotEmpty(original))
                                props.setSelectedUserDetail(original);
                        }
                    }}
                >
                    <div className={"userGroup-tableColumn-totalUsers-cellWrapper noWrap-text-ellipsis d-flex justify-content-between " +
                            (isUserGroupMappingHidden? "userGroup-tableColumn-totalUsers-cellWrapper_noHover ":"")}>
                        <span>
                            {totalUsers} User(s)
                        </span>

                        {(!isUserGroupMappingHidden)? (
                            <img
                                src={ic_user_group_customize}
                                alt={"Gear Icon"}
                            />
                        ):""}
                    </div>
                </div>
            );
        },
    }
}

function getColumns_userGroupPermission(props) {
    let columnClassName = "userGroup-tableColumn-userGroupPermissions";

    return {
        headerCellClassName: "userGroup-tableColumn-userGroupPermissions-header " + columnClassName + " ",
        Header: "Group Permissions",
        id: "userGroupPermissions",
        accessor: "UserGroupPermissions",
        bodyCellClassName: columnClassName + " ",
        Cell: (cellProps) => {
            let rowIdx = func_validation.getTableRowIndex(cellProps);
            let isSubrow = func_validation.isTableRowIndexSubrow(cellProps);
            let original = func_validation.getTableRowOriginalValue(cellProps);
            let selectedUsers = func_validation.getObjectPropertyValue(cellProps, "value");
            let totalUsers = func_validation.getArrayLength(selectedUsers, 0);
            let selectedIndexes = [];
            let userGroupPermissionListDisplay = [];
            if (func_validation.isArrayNotEmpty(selectedUsers) &&
                func_validation.isUserAccessGranted(props, "Internal_Permission_View")) {
                userGroupPermissionListDisplay = selectedUsers.map((permissionObj, idx) => {
                    let selectedIndex = func_validation.getObjectPropertyValue(permissionObj, "selectedIndex");
                    let userGroupPermissionName = func_validation.getObjectPropertyValue(permissionObj, "UserGroupPermission");
                    selectedIndexes.push(selectedIndex);

                    return (<div key={idx}>{func_validation.convertCamelCaseToWords(userGroupPermissionName)}</div>);
                })
            }

            let isUserGrouPermissionHidden = func_validation.isUserAccessDenied(props, "Internal_Permission_View");
            if (isUserGrouPermissionHidden && isSubrow) return "";

            return isSubrow? (
                <div className={"userGroup-tableColumn-userGroupPermissions-cell-subrow"}>
                    {userGroupPermissionListDisplay}
                </div>
            ):(
                <div className={"userGroup-tableColumn-userGroupPermissions-cell"}
                    onClick={() => {
                        if (!isUserGrouPermissionHidden) {
                            // User Modal
                            if (props.setIsModalVisible_userGroupPermission)
                                props.setIsModalVisible_userGroupPermission(true);

                            // User List
                            if (props.setSelectedUserGroupPermissionIndexList &&
                                func_validation.isArray(selectedIndexes))
                                props.setSelectedUserGroupPermissionIndexList(selectedIndexes);

                            // Set user email
                            if (props.setSelectedUserGroupPermissionDetail &&
                                func_validation.isObjectNotEmpty(original))
                                props.setSelectedUserGroupPermissionDetail(original);

                            if (props.setSeletedRowIdx)
                                props.setSeletedRowIdx(rowIdx);
                        }
                    }}
                >
                    <div className={"userGroup-tableColumn-userGroupPermissions-cellWrapper noWrap-text-ellipsis d-flex justify-content-between " +
                            (isUserGrouPermissionHidden? "userGroup-tableColumn-userGroupPermissions-cellWrapper_noHover ":"")}>
                        <span>
                            {totalUsers} Permission(s)
                        </span>

                        {(!isUserGrouPermissionHidden)? (
                            <img
                                src={ic_user_group_customize}
                                alt={"Gear Icon"}
                            />
                        ):""}
                    </div>
                </div>
            );
        },
    }
}